import { useMutation, useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getReportUrlById, getMeasurementReportUrl } from 'services/reports';
import { queryKeys } from 'utils/query';
import { displayNotificationSuccess } from 'utils/notifications';
import { FileType, downloadFile } from 'utils/fileManagement';

interface InputProps {
  measurementId?: string;
}

export const useMeasurementReportPdf = (input: InputProps) => {
  return useQuery({
    queryKey: [queryKeys.measurementPdf, input.measurementId],
    queryFn: () => getMeasurementReportUrl(input.measurementId),
    enabled: !!input.measurementId,
    gcTime: 0,
  });
};

export const useMeasurementReportDownload = () => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: (input: InputProps) => getMeasurementReportUrl(input.measurementId),
    onSuccess: (data, variables) => {
      if (data && variables.measurementId) {
        downloadFile(data, variables.measurementId, FileType.measurement);
        URL.revokeObjectURL(data);
        displayNotificationSuccess({ message: t('pdf_download_started') });
      }
    },
  });
};

export const useReportDownload = () => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: (id: string) => getReportUrlById({ id }),
    onSuccess: (data, variables) => {
      if (data) {
        downloadFile(data, variables, FileType.summary);
        URL.revokeObjectURL(data);
        displayNotificationSuccess({ message: t('pdf_download_started') });
      }
    },
  });
};
